import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;
                text-transform: capitalize;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            text-transform: capitalize;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1200px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;

        .cards-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 30px;
            
            .item-wrapper {
                background: white;
                border-radius: 20px;
                padding: 40px 30px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                text-align: center;
                box-shadow: 0 15px 35px rgba(0,0,0,0.06);
                border: 1px solid rgba(0,0,0,0.03);
                transition: all 0.3s ease;

                &:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 20px 45px rgba(0, 169, 196, 0.15);
                    border-color: rgba(0, 169, 196, 0.3);
                }

                h2 {
                    color: #334155;
                    font-size: 1.4em;
                    margin: 0 0 25px 0;
                    font-weight: 700;
                    line-height: 1.4;
                }

                a {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    color: #00A9C4;
                    text-decoration: none;
                    font-weight: 600;
                    padding: 12px 24px;
                    border-radius: 50px;
                    background: rgba(0, 169, 196, 0.1);
                    transition: all 0.2s ease;
                    font-size: 1.05em;

                    &:hover {
                        background: #00A9C4;
                        color: white;
                        transform: scale(1.05);
                    }

                    svg {
                        font-size: 1.2em;
                        transition: transform 0.2s ease;
                    }

                    &:hover svg {
                        transform: translateX(3px);
                    }
                }
            }
        }
    `
};

export default S;